import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { SettingsCentersContext } from '@/pages/settings-centers-page/SettingsCentersPage';

import FilterItemWrapper from '../fields/FilterItemWrapper';
import Input from '../fields/Input';
import Select from '../fields/Select';

export type CenterFilter = {
  name?: string;
  branchOfficeId?: string;
  workshopId?: string;
};

export type CentersFiltersProps = {
  updateFilter: (key: string, value: string) => void;
  filter: CenterFilter;
};

const CentersFilters: FC<CentersFiltersProps> = ({ updateFilter, filter }) => {
  const { t } = useTranslation();
  const { branchOffices, workshops } = useContext(SettingsCentersContext);

  const filters = () => {
    return [
      <Input
        key="name"
        name="name"
        onChange={(value) => updateFilter('name', value as string)}
        onBlur={() => {}}
        error=""
        required={false}
        label={t('centersSettingsPage.name')}
        value={filter.name || ''}
      />,

      <Select
        key="branchOffice"
        name="branchOffice"
        options={branchOffices}
        onChange={(value) => updateFilter('branchOfficeId', value as string)}
        onBlur={() => {}}
        error=""
        required={false}
        label={t('centersSettingsPage.branchOffice')}
        value={filter.branchOfficeId || ''}
        clearable
      />,

      <Select
        key="workshop"
        name="workshop"
        options={workshops}
        onChange={(value) => updateFilter('workshopId', value as string)}
        onBlur={() => {}}
        error=""
        required={false}
        label={t('centersSettingsPage.workshop')}
        value={filter.workshopId || ''}
        clearable
      />,
    ];
  };

  return (
    <>
      {filters().map((filter) => (
        <FilterItemWrapper key={filter.key}>{filter}</FilterItemWrapper>
      ))}
    </>
  );
};

export default CentersFilters;
